import axios from 'axios';

// Используем переменную окружения для production или localhost для development
// baseURL уже добавляет /api, поэтому указываем только домен
const API_URL = process.env.REACT_APP_API_URL || 
  (window.location.hostname === 'skillgate.pro' || window.location.hostname === 'www.skillgate.pro'
    ? 'https://api1.skillgate.pro/api'  // Через Nginx на HTTPS
    : 'http://localhost:8000/api');

const api = axios.create({
  baseURL: API_URL,
  timeout: 30000, // 30 секунд timeout
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Более детальная обработка ошибок
    if (error.message === 'Network Error') {
      console.error('Network Error:', {
        url: error.config?.url,
        baseURL: error.config?.baseURL,
        method: error.config?.method,
        hasToken: !!localStorage.getItem('token'),
      });
    }
    return Promise.reject(error);
  }
);

export const auth = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getMe: () => api.get('/auth/me'),
  updateMe: (data) => api.put('/auth/me', data),
  sendVerificationCode: (email) => api.post('/auth/send-verification-code', { email }),
  verifyCode: (email, code) => api.post('/auth/verify-code', { email, code }),
  forgotPassword: (email) => api.post('/auth/forgot-password', { email }),
  resetPassword: (email, code, newPassword) => api.post('/auth/reset-password', { email, code, new_password: newPassword }),
  getTariffInfo: () => api.get('/auth/tariff'),
  getResourcesStats: () => api.get('/auth/resources-stats'),
  getPurchasedServices: () => api.get('/auth/purchased-services'),
  purchaseTariff: (data) => api.post('/auth/purchase-tariff', data),
  purchaseService: (data) => api.post('/auth/purchase-service', data),
};


export const questionBanks = {
  create: (formData) => api.post('/question-banks', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  getAll: () => api.get('/question-banks'),
  getOne: (id) => api.get(`/question-banks/${id}`),
  delete: (id) => api.delete(`/question-banks/${id}`),
  getCatalog: () => api.get('/question-banks/catalog'),
  cloneBank: (id) => api.post(`/question-banks/${id}/clone`),
};

export const testSchemas = {
  create: (data) => api.post('/test-schemas', data),
  getAll: () => api.get('/test-schemas'),
  delete: (id) => api.delete(`/test-schemas/${id}`),
};

export const invitations = {
  getAll: () => api.get('/invitations'),
  create: (data) => api.post('/test-invitations', data),
  getByTestSchema: (testSchemaId) => api.get(`/test-schemas/${testSchemaId}/invitations`),
  getResults: (invitationId) => api.get(`/test-invitations/${invitationId}/results`),
  payForResults: (invitationId) => api.post(`/test-invitations/${invitationId}/pay-for-results`),
  updateStatus: (invitationId, data) => api.put(`/test-invitations/${invitationId}/status`, data),
  archive: (invitationId, isArchived) => api.put(`/test-invitations/${invitationId}/archive?is_archived=${isArchived}`),
};

export const candidate = {
  getTest: (invitationCode) => axios.get(`${API_URL}/candidate/test/${invitationCode}`),
  submitTest: (invitationCode, answers) => axios.post(`${API_URL}/candidate/test/${invitationCode}/submit`, answers),
};

export const payments = {
  create: (formData) => api.post('/payments', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  getAll: () => api.get('/payments'),
  getOne: (id) => api.get(`/payments/${id}`),
  verify: (paymentId) => api.get(`/payments/verify/${paymentId}`),
  getReceipt: (id) => api.get(`/payments/${id}/receipt`, { responseType: 'blob' }),
};

export const feedback = {
  create: (data) => api.post('/feedback', data),
};

export const admin = {
  getAllUsers: () => api.get('/admin/users'),
  deleteUser: (userId) => api.delete(`/admin/users/${userId}`),
};

export default api;

